<div class="material-home">
  <div class="material-home__content">
    <div class="material-home__header">
      <div>
        <h1 class="page-title">Materials</h1>
        <p class="page-subtitle">Manage your material catalog and inventory.</p>
      </div>
    </div>

    <app-item-browser
      [data]="materialState.data()"
      [config]="materialsConfig"
      [pagination]="materialsPagination"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-item-browser>
  </div>
</div>
